import { AxiosResponse } from 'axios';
import { snakeCaseKeys } from 'helpers/utils';
import { get, post, remove } from 'services/api';
import { IDeathsFormData } from 'views/public/DeathsView/components/DeathsForm/types';

export const getAll = (
  limit: number,
  page: number,
  search: string,
  sortKey: string,
  sortType: string,
): Promise<AxiosResponse> =>
  get(
    `deaths?limit=${limit}&page=${page}&search=${search}&sortKey=${sortKey}&sortType=${sortType}`,
  );

export const getForm = (): Promise<AxiosResponse> => get('deaths/form');

export const getOne = (id: string): Promise<AxiosResponse> => get(`deaths/${id}`);

export const save = (data: IDeathsFormData, id: string): Promise<AxiosResponse> => {
  const formData = new FormData();
  formData.append(
    'person',
    JSON.stringify(snakeCaseKeys(data.person as unknown as Record<string, unknown>)),
  );
  formData.append(
    'spouse',
    JSON.stringify(snakeCaseKeys(data.spouse as unknown as Record<string, unknown>)),
  );
  if (data.person?.idCardFile) formData.append('person_id_card_file', data.person.idCardFile);
  if (data.person?.idCardBackFile)
    formData.append('person_id_card_back_file', data.person.idCardBackFile);
  if (data.person?.ketubaFile) formData.append('person_ketuba_file', data.person.ketubaFile);
  if (data.person?.marriageCertificateFile)
    formData.append('person_marriage_certificate_file', data.person.marriageCertificateFile);
  if (data.person?.getFile) formData.append('person_get_file', data.person.getFile);
  formData.append(
    'family',
    JSON.stringify(snakeCaseKeys(data.family as unknown as Record<string, unknown>)),
  );
  formData.append(
    'location',
    JSON.stringify(snakeCaseKeys(data.location as unknown as Record<string, unknown>)),
  );
  formData.append(
    'signers',
    JSON.stringify(snakeCaseKeys(data.signers as unknown as Record<string, unknown>)),
  );
  data.signers?.forEach((signer, i) => {
    formData.append(`signers_id_card_files[${i}]`, signer.idCardFile ?? '');
    formData.append(`signers_id_card_back_files[${i}]`, signer.idCardBackFile ?? '');
  });
  formData.append(
    'payment',
    JSON.stringify(snakeCaseKeys(data.payment as unknown as Record<string, unknown>)),
  );
  if (data.comments) formData.append('comments', data.comments);
  if (id) formData.append('_method', 'PUT');
  return post(`deaths${!id ? '' : `/${id}`}`, formData, { transformRequest: () => formData });
};

export const softDelete = (id: string): Promise<AxiosResponse> => remove(`deaths/${id}`);
